<template>
	<div class="profile profile-Client">
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 w-full">
				<vx-card class="info-card">
					<h2><b>{{ $t('profile') }}</b></h2>
					<table class="info-card__content">
						<tbody>
						<tr>
							<td>{{ $t('personName') }}</td>
							<td>{{ $store.state.auth.user.first_name}} {{ $store.state.auth.user.last_name}}</td>
						</tr>
						<tr>
							<td>E-Mail</td>
							<td>{{ $store.state.auth.user.email }}</td>
						</tr>
						<tr>
							<td>{{ $t('additionalEmail') }}</td>
							<td>{{  $store.state.auth.user.email_secondary }}</td>
						</tr>
						<tr>
							<td>{{ $t('phone') }}</td>
							<td>{{  $store.state.auth.user.phone }}</td>
						</tr>
						<tr>
							<td>{{ $t('sex') }}</td>
							<td>{{ genders.find(e=>e.id===$store.state.auth.user.gender) && genders.find(e=>e.id===$store.state.auth.user.gender).name }}</td>
						</tr>
						<tr>
							<td>{{ $t('country') }}</td>
							<td>{{ countries.find(e=>e.id===$store.state.auth.user.country) && countries.find(e=>e.id===$store.state.auth.user.country).name }}</td>
						</tr>
						</tbody>
					</table>
					<div class="bottom">
						<router-link to="/profile/edit">
							<vs-button>{{ $t('edit') }}</vs-button>
						</router-link>
					</div>
				</vx-card>
			</div>
			<div
				v-if="!!manager && Object.keys(manager).length !== 0"
				class="vx-col lg:w-1/2 w-full privatManager mt-10 lg:mt-0"
			>
				<vx-card class="info-card">
					<h2><b>{{ $t('yourPersonalManager') }}</b></h2>
					<div class="box info-card__content">
						<div class="photo">
							<img :src="manager.photo" alt="">
						</div>
						<b>{{ manager.username }}</b>
					</div>

					<div class="info-card__bottom">
						<vs-button @click="popupActive=true">{{ $t('requestAnotherManager') }}</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
		<vs-popup class="holamundo change-manager" :title="$t('writeReason')" :active.sync="popupActive">
			<vs-textarea v-model="description"></vs-textarea>
			<div class="vs-popup--button">
				<vs-button @click="acceptChangeManager" class="mr-3" color="warning">
					{{ $t('send') }}
				</vs-button>
				<vs-custom-button type="flat" @click="popupActive=false">
					{{ $t('cancel') }}
				</vs-custom-button>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import notifier from '../../mixins/notifier';

export default {
	name: "Client",
	mixins: [notifier],
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			manager: '',
			countries: [],
			genders: [],

		}
	},
	methods: {
		async acceptChangeManager() {
			try {
				this.$http.post('/client/profile/request-manager-change',this.$formData({message: this.description}))
				this.description = '';

				this.notifySuccess(this.$t('changingManagerRequestIsSent'));
				this.popupActive = false;

			}catch (e) {
				this.notifyError(e.message);
				this.popupActive = false;
			}
		}
	},
	async created() {
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.genders = (await this.$http.get('/settings/get-genders')).data.data
		this.manager = (await this.$http.get('/client/profile/get-manager')).data.data
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";

.profile {
	h2 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
	}

	.vx-card {
		height: 100%;
	}

	.info-card {
		.vx-card__collapsible-content,
		.vx-card__body {
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		&__content {
			flex-grow: 1;
		}
	}

	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}

		}
	}

	.privatManager {
		.photo {
			width: 150px;
			height: 150px;
			border-radius: 10px;
			overflow: hidden;
			margin: 15px 15px;


			img {
				max-width: 100%;
			}
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}

	&-Client {
		.vx-card {
			padding-right: 0 !important;
		}
	}
}

.holamundo.change-manager {
	.vs-popup {
		max-width: 400px !important;

		.vs-textarea {
			height: 100px;
		}

		&--title {
			h3 {
				color: $warning;
			}
		}

		&--close {
			color: $warning;
		}

		p {
			padding: 1rem;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			border-top: 1px solid #e4e4e4;
			padding: 1rem;
			padding-bottom: 0.5rem;
		}
	}
}
</style>
